import { FORMIK_EMPTY_VALUE } from '../../../constants/validation'

export function getAITextGenerationFormFieldsTemplateNextValue() {
  return FORMIK_EMPTY_VALUE
}
